var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Icon',{staticClass:"u-mr--xs u-ml--xs",attrs:{"fill":_vm.active ? 'success' : 'medium-gray',"size":32,"size-mobile":24,"icon":_vm.iconRating}})}
var staticRenderFns = []

export { render, staticRenderFns }